import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Angle from '../../../../../../../components/global/Angle';
import Button from '../../../../../../../components/global/Button';

const propTypes = {
  printBackgrounds: PropTypes.array.isRequired,
  foregroundThumbnais: PropTypes.array.isRequired,
  onPrevBackground: PropTypes.func.isRequired,
  onNextBackground: PropTypes.func.isRequired,
};

const MatchedPhotoBackgroundSelectionActions = ({
  printBackgrounds,
  foregroundThumbnais,
  onPrevBackground,
  onNextBackground,
}) => {
  if (
    !printBackgrounds ||
    !printBackgrounds.length ||
    !foregroundThumbnais ||
    !foregroundThumbnais.length
  ) {
    return null;
  }

  return (
    <Fragment>
      <p className="matched-grid-photo-backgrond-swipe-notice">
        Swipe &larr;&rarr; to preview backdrops
      </p>
      <Button
        btnStyle="reset"
        className="matched-grid-photo-background-swipe-action left"
        onClick={onPrevBackground}
      >
        <Angle direction="left" />
      </Button>
      <Button
        btnStyle="reset"
        className="matched-grid-photo-background-swipe-action right"
        onClick={onNextBackground}
      >
        <Angle direction="right" />
      </Button>
    </Fragment>
  );
};

MatchedPhotoBackgroundSelectionActions.propTypes = propTypes;

export default MatchedPhotoBackgroundSelectionActions;
